import { usePermissions } from 'react-admin';
import { hasPermission, type PermissionKey } from '../permissions';
import { useFeature } from '../featureFlags/FeatureGate';

/**
 * Działy przyjęcia zleceń we froncie (makieta back office v2, fala B,
 * 21.10.2026) — lustro `intake/intake-departments.ts` z API.
 *
 * Przełącznik `intakeDepartments` wyłączony — wystarcza wspólne
 * „Przyjęcie zleceń” (`ORDER_INTAKE`), jak dotąd. Włączony — CS
 * i Administracja osobno (`INTAKE_CS`, `INTAKE_ADMINISTRATION`). Front tylko
 * ukrywa, czego dział nie robi; rozstrzyga API (`IntakeAccessGuard`).
 */

/** Klucze przełączników — dane z rejestru API, nie przemianowujemy. */
export const FEATURE_INTAKE_DEPARTMENTS = 'intakeDepartments';
export const FEATURE_INTAKE_CONTROL_WINDOW = 'intakeControlWindow';
export const FEATURE_INTAKE_HANDOFF = 'intakeHandoff';

export type IntakeSide = 'cs' | 'administration';

export const INTAKE_SIDE_LABELS: Record<IntakeSide, string> = {
  cs: 'CS',
  administration: 'Administracja',
};

const SIDE_PERMISSION: Record<IntakeSide, PermissionKey> = {
  cs: 'INTAKE_CS',
  administration: 'INTAKE_ADMINISTRATION',
};

/** Czy rola pracuje po stronie działu — ta sama reguła co w API. */
export function intakeSideAllowed(
  role: string | null | undefined,
  side: IntakeSide,
  departmentsOn: boolean,
): boolean {
  return departmentsOn
    ? hasPermission(role, SIDE_PERMISSION[side])
    : hasPermission(role, 'ORDER_INTAKE');
}

/** Czy zalogowany pracuje po stronie działu (z przełącznikiem z sesji). */
export function useIntakeSide(side: IntakeSide): boolean {
  const { permissions } = usePermissions<string>();
  const departmentsOn = useFeature(FEATURE_INTAKE_DEPARTMENTS);
  return intakeSideAllowed(permissions, side, departmentsOn);
}
